import { render, staticRenderFns } from "./workshop-live.vue?vue&type=template&id=26dae077&"
import script from "./workshop-live.vue?vue&type=script&lang=js&"
export * from "./workshop-live.vue?vue&type=script&lang=js&"
import style0 from "./workshop-live.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports